export const BOOKING_OPTION_PREFIX = 'booking-option';
export const PRIVATE_TOKEN = 'private-booking-fields';
export const AUTO_CHECKOUT_USER_ID = 664;
